import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsString, ValidateNested } from "class-validator";

export class MapperSuggestion {
  @Expose()
  @IsString()
  oldValue!: string;
  @Expose()
  @IsString()
  newValue!: string;
}

export class AttributePrototypeMapper {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  oldValue!: string;
  @Expose()
  @IsString()
  newValue!: string;
  @Expose()
  @IsArray()
  @IsString({ each: true })
  usedInAttributes!: Array<string>;
}

export class AttributePrototypeMapperResponse extends GenericTableResponse<AttributePrototypeMapper> {
  @Expose()
  @Type(() => AttributePrototypeMapper)
  @IsArray()
  @ValidateNested()
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  items!: Array<AttributePrototypeMapper>;
}
